import Vue from "vue";
import Router from "vue-router";
import productRoute from "./modules/product";
import accountRoute from "./modules/account";
import userRoute from "./modules/user";
import orderRoute from "./modules/order";
import payRoute from "./modules/pay";
import ServeRoute from "./modules/serve";
import NewsRoute from "./modules/news";
import Activity from "./modules/activity";
import { isLogin } from "@/utils/auth";

const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch((err) => err);
};

Vue.use(Router);

const RouterInstance = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            component: () => import("@/views/index/Index.vue"),
            meta: {
                title: "油柑网",
            },
        },
        {
            path: "/category",
            name: "category",
            component: () => import("@/views/category/Category.vue"),
            meta: {
                title: "商品目录-油柑网",
            },
        },
        {
            path: "/cart",
            name: "cart",
            component: () => import("@/views/cart/Cart.vue"),
            meta: {
                title: "购物车-油柑网",
            },
        },
        ...productRoute,
        ...accountRoute,
        ...userRoute,
        ...orderRoute,
        ...payRoute,
        ...ServeRoute,
        ...NewsRoute,
        ...Activity,
    ],
});

RouterInstance.beforeEach((to, from, next) => {
    const default_title = "油柑网";
    let documentTitle = to.meta.title;
    let requiresAuth = to.meta.requiresAuth;
    let bodyColor = to.meta.bodyColor || false;
    document.title = documentTitle || default_title;
    if (bodyColor) {
        document.body.style.backgroundColor = "#fff";
    } else {
        document.body.style.backgroundColor = "#f6f6f6";
    }
    //需要授权的页面
    if (requiresAuth) {
        if (isLogin()) {
            next();
        } else {
            window.location.href = "/account/login/password";
        }
    } else {
        next();
    }
});

export default RouterInstance;
